import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHookstate } from "@hookstate/core";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "assets/svgIcons/CheckIcon";
import ExclamationMarkIconWithBorder from "assets/svgIcons/ExclamationMarkWithRedBg";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
  CHATMESSAGE,
} from "../../../../globalStore/globalStore";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserAdmin,
  isUserBasic,
  isUserMaster,
  isUserReadOnly,
  isUserSupport,
  fleetViewMode
} from "../../../../constant";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import TagIcon from "../../../../assets/svgIcons/FleetIcon/TagIcon";
import SettingIcon from "../../../../assets/svgIcons/FleetIcon/SettingIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CheckAdminIcon from "assets/svgIcons/CheckedAdminIcon";
import PowerIcon from "../../../../assets/svgIcons/FleetIcon/PowerIcon";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import KeyIcon from "../../../../assets/svgIcons/FleetIcon/KeyIcon";
import KeyShieldIcon from "../../../../assets/svgIcons/FleetIcon/KeyShieldIcon";
import { Tooltip, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { MobileHeader } from "assets/css/globle";
import { ReactComponent as CarIconLegendIcon } from "assets/svgIcons/MapLegendPopup/Status/Outofservice.svg";
import NotCommunicating from "assets/svgIcons/NotCommunicating";
import MarshalsIcon from "assets/svgIcons/CarType/Marshals";
import FbIcon from "assets/svgIcons/CarType/F&B";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";
import PaceIcon from "assets/svgIcons/MapLegendPopup/PaceAlert/PaceIcon";
import OnChargeIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/OnCharge";
import UnKnowIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/UnKnownIcon";
import NotGuardianCapableIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/NotGuardianCapable";
import DistanceHiddenIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/DistanceHiddenIcon";
import DistanceShowIcon from "assets/svgIcons/MapLegendPopup/CarLocation/Location";
import LockIcon from "assets/svgIcons/LockIcon";
import UnLockIcon from "assets/svgIcons/UnlockIcon";
import BatteryLowIcon from "assets/svgIcons/BatteryIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import SmallListIcon from "assets/svgIcons/SmallList";
import BigListIcon from "assets/svgIcons/BigList";
import UpdatesPendingIcon from "assets/svgIcons/UpdatesPendingIcon"

import {
  Container,
  TagsWrapper,
  ActionWrapper,
  Tag,
  SettingIconWrapper,
  KeyIconWrapper,
  KeyPopup,
  ChangeSettingModalWrapper,
} from "../../../../pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import ChangeSettingIcon from "../../../../assets/svgIcons/IconDetailIcon";
import CarTagIcon from "assets/svgIcons/LocationPointIcon";
import DescendingIcon from "assets/svgIcons/DescendingIcon";
import AscendingIcon from "assets/svgIcons/AscendingIcon";
import CloseIcon from "assets/svgIcons/CloseIcon";
import SignalIcon from "assets/svgIcons/SignalIcon";
import {
  MESSAGE_FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  CAR_NUMBER_MESSAGE,
} from "../../../../globalStore/globalStore";
import { LIST_BY_GLOBAL_STATES } from "../../../../globalStore/globalStore";
import SelectStyled from "../../../../commonComponents/FormElement/Select";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import ChatIcon from "assets/svgIcons/ChatIcon";
import SettingIconNew from "assets//svgIcons/SideNav/Settings";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseOutIcon from "assets/svgIcons/ModalCloseOutIcon";
import MobileSignalIcon from "assets/svgIcons/MobileSignalIcon";
import { FleetCarLegend } from "commonComponents/CarDetails/CarDetailsStyled";
import Link from "@mui/material/Link";
import CarSettings from "commonComponents/CarDetails/CarSettings";
import { useTranslation } from "react-i18next";
import { uuid } from "_helperFunctions/uuid";
import { mapHelpers } from "pages/Pins/utils/mapHelpers";
import TableListIcon from "assets/svgIcons/TableList";

export const SortByHeader = () => {
  const { t } = useTranslation();

  const { TagActive, showTaggedCarArray, showTaggedCarArrayNew } = useHookstate(MAP_GLOBAL_STATES);
  const { carMessageDataHandler } = useHookstate(CAR_NUMBER_MESSAGE);
  const { MessageCount } = useHookstate(CHATMESSAGE);

  const {
    selectedCarList,
    setMsgToSingleCar,
    selectedGpsCarList,
    closingPopup,
    selectFleetCarsData2,
    toggleFleetCarList,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { showTagCarsState, showTagCarsStatenew } = useHookstate(COMMON_COMPONENTS_STATES);

  const {
    showFilterbattry,
    showFilterServices,
    showFilterNotCommunicating,
    listBy,
    sortBy,
    modeBy,
    sortButton,
    memberCar
  } = useHookstate(LIST_BY_GLOBAL_STATES);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
  const {
    stagingModeData,
    siteSettingsData,
    getUserRole,
    getPrivilegeAction,
  } = useSelector((state) => state.commonReducers) || [];

  const dispatch = useDispatch();

  const [threeDotState, setThreeDotState] = useState(false);
  const [yards, setYards] = useState(false);
  const [meters, setMeters] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [keyCheck, setKeyCheck] = useState(false);
  const [adminCheck, setAdminCheck] = useState(false);
  const [openSettingModal, setOpenSettingModal] = React.useState(false);
  const [isShownCarDetail, setIsShownCarDetail] = useState(false);
  const [Setting, setSetting] = React.useState("Use fleet setting");
  const [newCarType, setCarType] = React.useState("Normal");
  const [SpeedLimit, setSpeedLimit] = React.useState("");
  const [Distances, setDistances] = React.useState("Hide Distances");

  const descriptionElementRef = React.useRef(null);
  const isMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  );

  const privilege = "AdminCode";
  const filtercartypedata = cartypecheck();
  const maxHoles = MxnumberOfHoles();
  const Units = DistanceUnitsEnableCar();
  const DistanceUnitsnew = Distance();
  const gps = selectedGpsCarList.get();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "360px",
    width: "calc(100% - 40px)",
    bgcolor: "#ffffff",
    zIndex: 1,
    maxHeight: "calc(100% - 100px)",
  };

  const legendStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "912px",
    width: "calc(100% - 40px)",
    border: "none",
    background: "transparent",
    padding: "9px",
    outline: "none",
  };

  React.useEffect(() => {
    if (openSettingModal) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openSettingModal]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getPrivilegeServices(privilege));
  }, []);

  useEffect(() => {
    if (siteSettingsData && Object.keys(siteSettingsData).length > 0) {
      if (siteSettingsData?.GuardianMode === 1) {
        modeBy.set("NORMAL");
      } else if (siteSettingsData?.GuardianMode === 2) {
        modeBy.set("STAGING");
      } else {
        modeBy.set("LOCKDOWN");
      }
    }
  }, [siteSettingsData]);

  useEffect(() => {
    let showCNC = JSON.parse(localStorage.getItem("showCNC"));
    let ShowCOS = JSON.parse(localStorage.getItem("ShowCOS"));
    let showCarCharger = JSON.parse(localStorage.getItem("showCarCharger"));
    let showMember = JSON.parse(localStorage.getItem("MemberCache"));
    showMember && memberCar.set(showMember);
    showCNC && showFilterNotCommunicating.set(showCNC);
    ShowCOS && showFilterServices.set(ShowCOS);
    showCarCharger && showFilterbattry.set(showCarCharger);
  }, [
    showFilterbattry.get(),
    showFilterServices.get(),
    showFilterNotCommunicating.get(),
    memberCar.get()
  ]);

  const yardsHamdle = () => {
    setYards(true);
    setMeters(false);
  }

  const metersHandle = () => {
    setYards(false);
    setMeters(true);
  }

  const handleOpen2 = () => setOpen2(true);

  const handleClose2 = () => setOpen2(false);

  const handleClose = () => {
    isLoading.set(false);
    setMsgToSingleCar.set(null);
    MessageCount.set(false);
  }

  const handleSettingClose = () => {
    setOpenSettingModal(true);
    setIsShownCarDetail(false);
    closingPopup.set(false);
  }

  const sendMsgToSelectedCars = (e) => {
    carMessageDataHandler.set(true);
    e.preventDefault();
    isLoading.set(true);
    setMsgToSingleCar.set(null);
    showTagCarsState.set(false);
    showTagCarsStatenew.set(false);
    MessageCount.set(true);
  }

  const SettingHandle = (e) => {
    setSetting(e.target.value);
  }

  const CarTypeHandle = (e) => {
    setCarType(e.target.value);
  }

  const handleSpeedLimit = (e) => {
    setSpeedLimit(e.target.value);
  }

  const handleDistance = (e) => {
    setDistances(e.target.value);
  }

  const allList = [
    {
      value: "NONE",
      label: t("None"),
    },
    {
      value: "CHARGING",
      label: t("Charging"),
    },
    {
      value: "ALERTS",
      label: t("Alerts"),
    },
    {
      value: "IN USE",
      label: t("In_use"),
    },
    {
      value: "ACTION ZONE",
      label: t("Action_Zone"),
    },
    {
      value: "STAGED",
      label: t("Staged"),
    },
    {
      value: "MEMBER CARS",
      label: t("Member_cars"),
    },
    {
      value: "ADMIN ONLY",
      label: "In tourn(Admin only)",
    },
  ];

  const allSortList = [
    {
      value: "car",
      label: t("Car"),
    },
    {
      value: "gpsiID",
      label: t("GPSI_ID"),
    },
    {
      value: "battery",
      label: t("Battery"),
    },
    {
      value: "location",
      label: t("Location"),
    },
    {
      value: "pace",
      label: t("Pace"),
    },
    {
      value: "player1",
      label: t("player1"),
    },
    {
      value: "player2",
      label: t("player2"),
    },
    {
      value: "lastlocation",
      label: t("Last_location"),
    },
    {
      value: "connectedSSID",
      label: t("Wifi_Network"),
    },
    {
      value: "lastRT",
      label: t("Last_RT"),
    },
    {
      value: "lastWiFi",
      label: t("Last_WIFI"),
    },
    {
      value: "simCard",
      label: t("SIM_Card"),
    },
    {
      value: "imei",
      label: t("IMEI"),
    },
    {
      value: "pmid",
      label: t("PMID"),
    },
    {
      value: "vapp",
      label: t("V*App"),
    },
    {
      value: "vui",
      label: t("V*UI"),
    },
    {
      value: "vlauncher",
      label: t("V*launcher"),
    },
    {
      value: "gg",
      label: t("GG"),
    },
    {
      value: "aos",
      label: t("AOS"),
    },
    {
      value: "modemFW",
      label: t("ModemFW"),
    },
    {
      value: "microFW",
      label: t("MicroFW"),
    },
    {
      value: "dev",
      label: t("Dev"),
    },
    {
      value: "ctl",
      label: t("CTL"),
    },
  ];

  function adminCodeAccess() {
    return (
      isUserAdmin(getUserRole && getUserRole?.Role) ||
      isUserSupport(getUserRole && getUserRole?.Role) ||
      getPrivilegeAction
    );
  }

  function getFinalSortListData() {
    if (
      isUserBasic(getUserRole && getUserRole?.Role) ||
      isUserReadOnly(getUserRole && getUserRole?.Role) ||
      isUserMaster(getUserRole && getUserRole?.Role)
    ) {
      let newData = allSortList.slice(0, 9);
      return newData;
    } else {
      return allSortList;
    }
  }

  const mode = [
    {
      value: "NORMAL",
      label: t("Normal"),
    },
    {
      value: "STAGING",
      label: t("Staging"),
    },
    {
      value: "LOCKDOWN",
      label: t("Lockdown"),
    },
  ];

  const handleChargingFilter = () => {
    localStorage.setItem("showCarCharger", !showFilterbattry.get());
    showFilterbattry.set(!showFilterbattry.get());
  }

  const handleMemberCarDisplay = () => {
    localStorage.setItem("MemberCache", !memberCar.get());
    memberCar.set(!memberCar.get());
  }

  const handleServiceFilter = () => {
    localStorage.setItem("ShowCOS", !showFilterServices.get());
    showFilterServices.set(!showFilterServices.get());
  }

  const handleNotCommunicatingFilter = () => {
    localStorage.setItem("showCNC", !showFilterNotCommunicating.get());
    showFilterNotCommunicating.set(!showFilterNotCommunicating.get());
  }

  const showTagCarDialogBoxWindow = () => {
    showTagCarsStatenew.set(false);
    showTagCarsState.set(true);
    let carsData = JSON.parse(localStorage.getItem("taggedCarsData"));
    if (carsData && carsData?.tagCarsDataFilters) {
      showTaggedCarArray.set([
        ...carsData?.tagCarsDataFilters,
        ...selectedCarList.get(),
      ]);
    }
  }

  const carList = selectedCarList.get();

  const changePropertyForSelectedCars = () => {
    showTaggedCarArrayNew.set([]);
    selectFleetCarsData2.set([]);
    TagActive.set(true);

    if (selectedCarList.get().length === 0) {
      showTagCarsStatenew.set(true);
    } else {
      closingPopup.set(true);
      setOpenSettingModal(true);
    }
  }

  function cartypecheck() {
    switch (newCarType) {
      case "Normal":
        return 0;
      case "Fleet Car":
        return 1;
      case "Marshal Car":
        return 2;
      case "Special Need Car":
        return 3;
      case "Beverage Car":
        return 4;
      default:
        return <span className="card-view">Car Name Not Available</span>;
    }
  }

  function MxnumberOfHoles() {
    if (Setting === "Use fleet setting") {
      return "Use fleet setting";
    } else if (Setting === 9) {
      return 9;
    } else if (Setting === 18) {
      return 18;
    } else {
      return 0;
    }
  }

  function DistanceUnitsEnableCar() {
    if (Setting === "Hide Distances") {
      return 0;
    } else if (Setting === "Show Distances") {
      return 1;
    } else {
      return 2;
    }
  }

  function Distance() {
    if (yards) {
      return 1;
    } else {
      return 2;
    }
  }

  const saveEntity = () => {
    gps.forEach((item) => {
      const payload = {
        GpsiCarId: item,
        CarType: filtercartypedata,
        MaxSpeed: SpeedLimit.toString(),
        MaxHolesAllowedCar: maxHoles,
        DistancesEnabledCar: Units,
        DistanceUnits: DistanceUnitsnew,
      };
      dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
        dispatch(COMMON_SERVICES.getProductData(payload));
      });
      setIsShownCarDetail(false);
      setOpenSettingModal(false);
    });
  }

  const handleToggleSmallList = () => {
    toggleFleetCarList.set(fleetViewMode.SmallList);
    localStorage.setItem("FleetDataView", fleetViewMode.SmallList);
  }

  const handleToggleGridList = () => {
    toggleFleetCarList.set(fleetViewMode.GridList);
    localStorage.setItem("FleetDataView", fleetViewMode.GridList);
  }

  const handleToggleTableList = () => {
    toggleFleetCarList.set(fleetViewMode.TableList);
    localStorage.setItem("FleetDataView", fleetViewMode.TableList);
  }

  return (
    <>
      <Container className="display">
        <ActionWrapper>
          <div className="label-wrapper">
            <label htmlFor="">{t("List_By")}</label>{" "}
            <SelectStyled value={listBy.get()} data={allList} />
          </div>
          <div className="label-wrapper">
            <label htmlFor="">{t("Sort_by")}</label>{" "}
            <SelectStyled value={sortBy.get()} data={getFinalSortListData()} />
            <Tooltip title="Sort">
              <div
                onClick={() =>
                  sortButton.get()
                    ? sortButton.set(false)
                    : sortButton.set(true)
                }
              >
                {sortButton.get() ? <DescendingIcon /> : <AscendingIcon />}
              </div>
            </Tooltip>
          </div>
          <div className="label-wrapper">
            <label htmlFor="">{t("Show")}</label>
            <div className="IconWrapper">
              <Tooltip title={t("Show_cars_not_communicating")}>
                <button onClick={handleNotCommunicatingFilter}>
                  <TagIcon
                    bg={
                      showFilterNotCommunicating.get()
                        ? "var(--theme-background)"
                        : "transparent"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Show_cars_out_of_service")}>
                <button onClick={handleServiceFilter}>
                  <SettingIcon
                    bg={
                      showFilterServices.get()
                        ? "var(--theme-background)"
                        : "transparent"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Show_cars_on_charger")}>
                <button onClick={handleChargingFilter}>
                  <PowerIcon
                    bg={
                      showFilterbattry.get()
                        ? "var(--theme-background)"
                        : "transparent"
                    }
                  />
                </button>
              </Tooltip>
              {isMemberCar && <Tooltip title={t("Show_member_cars")}>
                <button onClick={handleMemberCarDisplay}>
                  <MembercarIcon
                    width={30}
                    height={30}
                    bg={
                      memberCar.get()
                        ? "var(--theme-background)"
                        : "transparent"
                    }
                    opacity={0.6}
                  />
                </button>
              </Tooltip>}
            </div>
          </div>
          <div className="label-wrapper">
            <label htmlFor="">{t("Mode")}</label>
            <SelectStyled
              value={modeBy.get()}
              data={mode}
              disabled={
                isUserBasic(getUserRole && getUserRole?.Role) ||
                isUserReadOnly(getUserRole && getUserRole?.Role)
              }
            />

            <Tooltip title={t("Manual_unlock_code")}>
              <KeyIconWrapper>
                <IconButton
                  disabled={
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  onClick={() => {
                    setKeyCheck(!keyCheck);
                    if (!keyCheck) setAdminCheck(false);
                  }}
                >
                  <KeyIcon
                    style={{ cursor: "pointer" }}
                    color={keyCheck ? "var(--theme-background)" : "none"}
                  />
                </IconButton>
                {keyCheck ? (
                  <KeyPopup>
                    VDU/LT:{" "}
                    {stagingModeData && stagingModeData.length !== 0
                      ? stagingModeData?.UnlockCode
                      : siteSettingsData?.UnlockCode}
                    <span></span>
                  </KeyPopup>
                ) : (
                  <></>
                )}
              </KeyIconWrapper>
            </Tooltip>

            <Tooltip title={t("Admin_code")}>
              <KeyIconWrapper>
                <IconButton
                  disabled={
                    !adminCodeAccess()
                  }
                  onClick={() => {
                    setAdminCheck(!adminCheck);
                    if (!adminCheck) setKeyCheck(false);
                  }}
                >
                  <KeyShieldIcon
                    style={{ cursor: "pointer" }}
                    color={adminCheck ? "var(--theme-background)" : "none"}
                  />
                </IconButton>
                {adminCheck ? (
                  <KeyPopup className="for-admin">
                    Code:{" "}
                    {stagingModeData && stagingModeData.length !== 0
                      ? stagingModeData?.UnlockCode
                      : siteSettingsData?.AdminCode}
                    <span></span>
                  </KeyPopup>
                ) : (
                  <></>
                )}
              </KeyIconWrapper>
            </Tooltip>
          </div>

          <TagsWrapper>
            <Tag
              onClick={sendMsgToSelectedCars}
              style={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                )
                  ? {
                    backgroundColor: "#d3d3d3",
                    cursor: "no-drop",
                  }
                  : {}
              }
              disabled={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) ||
                isUserBasic(getUserRole && getUserRole?.Role) ||
                isUserReadOnly(getUserRole && getUserRole?.Role)
              }
            >
              <ChatIcon />
              <span>{t("Send_message_to_selected_cars")}</span>
            </Tag>
            <Tag
              onClick={changePropertyForSelectedCars}
              disabled={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                )
              }
            >
              <SettingIconNew
                width={14}
                height={14}
                color="var(--inner-section-bg)"
              />
              <span>{t("Change_settings_for_selected_cars")}</span>
            </Tag>

            <Modal
              open={closingPopup.get()}
              onClose={handleSettingClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <CarSettings onClose={handleSettingClose} />
              </Box>
            </Modal>

            <Tag
              onClick={showTagCarDialogBoxWindow}
              style={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                )
                  ? {
                    backgroundColor: "#d3d3d3",
                    cursor: "no-drop",
                  }
                  : {}
              }
              disabled={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <CarTagIcon
                color="var(--inner-section-bg)"
                width={11.5}
                height={16}
              />
              <span className="display">{t("Find_Cars")}</span>
            </Tag>
          </TagsWrapper>

          <Modal
            open={isLoading.get()}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <MsgToSelectedCarsCmp cancelClick={handleClose} />
            </Box>
          </Modal>
        </ActionWrapper>
        <Tooltip title={t("Fleet_legend")}>
          <SettingIconWrapper>
            <ChangeSettingIcon
              onClick={handleOpen2}
              style={{ cursor: "pointer" }}
            />
          </SettingIconWrapper>
        </Tooltip>
      </Container>
      <Modal
        open={open2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={handleClose2}
      >
        <Box sx={legendStyle}>
          <FleetCarLegend className="fleet-car-legend">
            <div className="modal-header">
              <h2>Fleet Car Status</h2>
              <button className="close-icon" onClick={handleClose2}>
                <CloseOutIcon />
              </button>
            </div>
            <div className="modal-body">
              <div className="first-section">
                <ul className="alerts-icon-wrapper">
                  <li>{t("Alerts")}</li>
                  <li>
                    <span>35</span>
                    {t("Car_alert_detected")}
                  </li>
                  <li>
                    <span>35</span>
                    {t("Charge_alert_detected")}
                  </li>
                  <li>
                    <span>35</span>
                    {t("Alert_detected,_not_communicating")}
                  </li>
                  <li>
                    <span>35</span>
                    {t("Non-guardian_car")}
                  </li>
                  <li>
                    <span>35</span>
                    {t("Car_out_of_service")}
                  </li>
                </ul>
                <ul>
                  <li>{t("Connected_States")}</li>
                  <li>
                    <span>
                      <NotCommunicating color="#FF0000" />
                    </span>
                    {t("Not_communicating")}
                  </li>
                  <li>
                    <span>
                      <SignalIcon
                        width="13px"
                        height="12.21px"
                        color="#5AADFF"
                      />
                    </span>
                    {t("Connected_via_Wi-Fi")}
                  </li>
                  <li>
                    <span>
                      <SignalIcon width="13px" height="12.21px" />
                    </span>
                    {t("Not_connected_via_Wi-Fi")}
                  </li>
                  <li>
                    <span>
                      <MobileSignalIcon
                        width="13px"
                        height="12.21px"
                        color="#5AADFF"
                      />
                    </span>
                    {t("Cellular_connected_via_Network")}
                  </li>
                  <li>
                    <span>
                      <MobileSignalIcon width="13px" height="12.21px" />{" "}
                    </span>
                    {t("Cellular_not_connected_via_Network")}
                  </li>
                  <li>
                    <span>
                      <UpdatesPendingIcon width="18px" height="18px" />{" "}
                    </span>
                    {t("Updates_pending")}
                  </li>
                </ul>
                <ul>
                  <li>{t("Car_type")}</li>
                  <li>
                    <span>
                      <MarshalsIcon />
                    </span>
                    {t("Marshal_cars")}
                  </li>
                  <li>
                    <span>
                      <FbIcon />
                    </span>
                    {t("Food_&_beverage_cars")}
                  </li>
                  <li>
                    <span>
                      <SpecialNeedsIcon />
                    </span>
                    {t("Special_needs_car")}
                  </li>
                  <li>
                    <span>
                      <MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} />
                    </span>
                    {t("Member_car")}
                  </li>
                  <li style={{ gap: 1 }}>
                    <span><MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} /> <SpecialNeedsIcon width={15} height={15} /></span>
                    {t("Member_/_Special_Needs")}
                  </li>
                  <li>
                    <span>
                      <CarIconLegendIcon width={17} height={17} />
                    </span>
                    {t("Out_of_service")}
                  </li>
                  <li>
                    <span>
                      <ExclamationMarkIconWithBorder width={17} height={17} />
                    </span>
                    {t("Critical_fault_detected")}
                  </li>
                </ul>
                <ul>
                  <li>{t("Pace_alerts")}</li>
                  <li style={{ gap: 6 }}>
                    <span>
                      <PaceIcon width={27} height={27} />
                    </span>
                    {t("Falling_behind_pace")}
                  </li>
                  <li style={{ gap: 6 }}>
                    <span>
                      <PaceIcon color="#FF0000" width={27} height={27} />
                    </span>
                    {t("Critically_behind_pace")}
                  </li>
                  <ul>
                    <li>{t("Speed_limit")}</li>
                    <li>
                      <span>7</span>
                      {t("Speed_limit_set")}
                    </li>
                  </ul>
                </ul>
                <ul>
                  <li>{t("Battery_status")}</li>
                  <li>
                    <span>
                      <BatteryLowIcon
                        width="15.07px"
                        height="8.14"
                        color="#00A692"
                      />
                    </span>
                    {t("Battery_ok")}
                  </li>
                  <li>
                    <span>
                      <BatteryLowIcon
                        width="15.07px"
                        height="8.14"
                        color="#FFE500"
                      />
                    </span>
                    {t("Battery_low")}
                  </li>
                  <li>
                    <span>
                      <BatteryLowIcon
                        width="15.07px"
                        height="8.14"
                        color="#FA3C30"
                      />
                    </span>
                    {t("Battery_critically_low")}
                  </li>
                  <li>
                    <span>
                      <OnChargeIcon width="15.07px" height="8.14" />
                    </span>
                    {t("On_charge")}
                  </li>
                </ul>
                <ul>
                  <li style={{ color: "transparent" }}>
                    {t("Battery_status")}
                  </li>
                  <li>
                    <span>
                      <BatteryWithPowerIcon
                        width="15.07px"
                        height="8.14"
                        color="#00A692"
                      />
                    </span>
                    {t("At_or_near_full_charge")}
                  </li>
                  <li>
                    <span>
                      <OnChargeIcon
                        width="15.07px"
                        height="8.14"
                        color="#FA3C30"
                      />
                    </span>
                    {t("Charging_inhibited")}
                  </li>
                  <li>
                    <span>
                      <UnKnowIcon />
                    </span>
                    {t("Unknown")}
                  </li>
                  <li>
                    <span>
                      <NotGuardianCapableIcon width={17} height={17} />
                    </span>
                    {t("Not_Guardian_capable")}
                  </li>
                </ul>
                <ul>
                  <li className="li-sub-heading">Courses</li>
                  {siteSettingsData &&
                    siteSettingsData?.Courses &&
                    siteSettingsData?.Courses?.length !== 0 ? (
                    siteSettingsData?.Courses?.map((item) => (
                      <li key={() => uuid()}>
                        <span
                          className="number-icon"
                          style={{
                            background:
                              siteSettingsData &&
                              mapHelpers.CourseBGColor(
                                siteSettingsData,
                                item?.Number
                              ),
                            color:
                              siteSettingsData &&
                              mapHelpers.CourseTxtColor(
                                siteSettingsData,
                                item?.Number
                              ),
                          }}
                        >
                          {item?.Number}
                        </span>
                        {item?.Name}
                      </li>
                    ))
                  ) : (
                    <></>
                  )}
                </ul>
                <ul>
                  <li>{t("Distances")}</li>
                  <li style={{ gap: 12 }}>
                    <span>
                      <b>yds</b>
                    </span>
                    {t("Distances_in_yards")}
                  </li>
                  <li>
                    <span>
                      <b>m</b>
                    </span>
                    {t("Distances_in_meters")}
                  </li>
                  <li>
                    <span>
                      <DistanceHiddenIcon width={15} height={15} />
                    </span>
                    {t("Distances_hidden")}
                  </li>
                  <li>
                    <span>
                      <DistanceShowIcon color="green" width={18} height={18} />
                    </span>
                    {t("Distances_shown")}
                  </li>
                </ul>
                <ul>
                  <li>{t("Holes_Info")}</li>
                  <li>
                    <span className="number-icon">18</span>
                    {t("Hole_Location")}
                  </li>
                  <li>
                    <span className="number-icon red">18</span>
                    {t("Max_holes_overridden")}
                  </li>
                </ul>
                <ul>
                  <li>{t("Car_Modes")}</li>
                  <li style={{ gap: 21 }}>
                    <span>
                      <LockIcon />
                    </span>
                    {t("Lockdown_mode_or_staged")}
                  </li>
                  <li>
                    <span>
                      <UnLockIcon />
                    </span>
                    {t("Normal_mode")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="modal-header">
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <Link
                  href="https://help.visage.golf/visage-2/"
                  underline="none"
                  target="_blank"
                >
                  {t("Visage_Help")}
                </Link>
                {"  "}
                {t("website")}
              </Typography>
            </div>
          </FleetCarLegend>
        </Box>
      </Modal>
      <MobileHeader>
        <h4>Fleet</h4>
        <IconButton onClick={() => setThreeDotState(!threeDotState)}>
          <h4>{t("Filter")}</h4>
          <KeyboardArrowDownIcon
            style={{
              fill: "#ffffff",
              transform: threeDotState && "rotate(180deg)",
            }}
          />
        </IconButton>
        {threeDotState && (
          <div className="open-section">
            <ActionWrapper>
              <div className="label-wrapper">
                <label htmlFor="">{t("List_By")}</label>{" "}
                <SelectStyled value={listBy.get()} data={allList} />
              </div>
              <div className="label-wrapper">
                <label htmlFor="">{t("Sort_by")}</label>{" "}
                <SelectStyled
                  value={sortBy.get()}
                  data={getFinalSortListData()}
                />
                <Tooltip title="Sort">
                  <div
                    onClick={() =>
                      sortButton.get()
                        ? sortButton.set(false)
                        : sortButton.set(true)
                    }
                  >
                    {sortButton.get() ? <DescendingIcon /> : <AscendingIcon />}
                  </div>
                </Tooltip>
              </div>
              <div className="label-wrapper">
                <label htmlFor="">{t("Show")}</label>
                <div className="IconWrapper">
                  <Tooltip title={t("Show_cars_not_communicating")}>
                    <button onClick={handleNotCommunicatingFilter}>
                      <TagIcon
                        bg={
                          showFilterNotCommunicating.get()
                            ? "var(--theme-background)"
                            : "transparent"
                        }
                      />
                    </button>
                  </Tooltip>

                  <Tooltip title={t("Show_cars_out_of_service")}>
                    <button onClick={handleServiceFilter}>
                      <SettingIcon
                        bg={
                          showFilterServices.get()
                            ? "var(--theme-background)"
                            : "transparent"
                        }
                      />
                    </button>
                  </Tooltip>

                  <Tooltip title={t("Show_cars_on_charger")}>
                    <button onClick={handleChargingFilter}>
                      <PowerIcon
                        bg={
                          showFilterbattry.get()
                            ? "var(--theme-background)"
                            : "transparent"
                        }
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div className="label-wrapper">
                <label htmlFor="">{t("Mode")}</label>
                <SelectStyled value={modeBy.get()} data={mode} />

                <Tooltip title={t("Manual_unlock_code")}>
                  <KeyIconWrapper>
                    <KeyIcon
                      // onClick={() => setKeyCheck(!keyCheck)}
                      onClick={() => {
                        setKeyCheck(!keyCheck);
                        if (!keyCheck) setAdminCheck(false);
                      }}
                      style={{ cursor: "pointer" }}
                      color={keyCheck ? "var(--theme-background)" : "none"}
                    />
                    {keyCheck ? (
                      <KeyPopup>
                        VDU/LT:{" "}
                        {stagingModeData && stagingModeData.length !== 0
                          ? stagingModeData?.UnlockCode
                          : siteSettingsData?.UnlockCode}
                        <span></span>
                      </KeyPopup>
                    ) : (
                      <></>
                    )}
                  </KeyIconWrapper>
                </Tooltip>

                <Tooltip title={t("Admin_code")}>
                  <KeyIconWrapper>
                    <IconButton
                      disabled={
                        !adminCodeAccess()
                      }
                      onClick={() => {
                        setAdminCheck(!adminCheck);
                        if (!adminCheck) setKeyCheck(false);
                      }}
                    >
                      <KeyShieldIcon
                        style={{ cursor: "pointer" }}
                        color={adminCheck ? "var(--theme-background)" : "none"}
                      />
                    </IconButton>
                    {adminCheck ? (
                      <KeyPopup className="for-admin">
                        Code:{" "}
                        {stagingModeData && stagingModeData.length !== 0
                          ? stagingModeData?.UnlockCode
                          : siteSettingsData?.AdminCode}
                        <span></span>
                      </KeyPopup>
                    ) : (
                      <></>
                    )}
                  </KeyIconWrapper>
                </Tooltip>
              </div>

              <TagsWrapper>
                <Tag
                  onClick={sendMsgToSelectedCars}
                  style={
                    getFeatureSetOption(
                      siteSettingsData?.Features,
                      getFeaturesList().real_time_tracking
                    )
                      ? {
                        backgroundColor: "#d3d3d3",
                        cursor: "no-drop",
                      }
                      : {}
                  }
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData?.Features,
                      getFeaturesList().real_time_tracking
                    ) &&
                    getUserRole &&
                    getUserRole.Role != 6
                  }
                >
                  <ChatIcon />
                  <span>{t("Send_message_to_selected_cars")}</span>
                </Tag>
                <Tag
                  onClick={changePropertyForSelectedCars}
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData?.Features,
                      getFeaturesList().real_time_tracking
                    ) &&
                    getUserRole &&
                    getUserRole.Role != 6
                  }
                >
                  <SettingIconNew
                    width={14}
                    height={14}
                    color="var(--inner-section-bg)"
                  />
                  <span>{t("Change_settings_for_selected_cars")}</span>
                </Tag>
                {isShownCarDetail && (
                  <Dialog
                    open={openSettingModal}
                    onClose={handleSettingClose}
                    maxWidth="xs"
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                  >
                    <ChangeSettingModalWrapper>
                      <div className="heading">
                        <h2>
                          <span className="setting-icon-wrapper">
                            <SettingIconNew
                              color="#000"
                              width={14}
                              height={14}
                            />
                          </span>
                          {t("Cars")} : {carList}
                        </h2>
                        <CloseIcon
                          onClick={handleSettingClose}
                          width={22}
                          height={22}
                        />
                      </div>
                      <DialogContent>
                        <div className="select-wrapper">
                          <p>{t("Max_Number_of_Holes")}</p>
                          <FormControl size="small">
                            <Select
                              value={Setting}
                              defaultValue={Setting}
                              name="CarSetting"
                              onChange={SettingHandle}
                              IconComponent={ExpandMoreIcon}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value="Use fleet setting">
                                {t("Use_fleet_setting")}
                              </MenuItem>
                              <MenuItem value="9">9</MenuItem>
                              <MenuItem value="18">18</MenuItem>
                              <MenuItem value="Unlimited">
                                {t("Unlimited")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="select-wrapper">
                          <p>{t("Car_type")}</p>
                          <FormControl size="small">
                            <Select
                              value={newCarType}
                              defaultValue={newCarType}
                              name="CarType"
                              onChange={CarTypeHandle}
                              IconComponent={ExpandMoreIcon}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                value="Normal"
                                style={{ display: "none" }}
                              >
                                {t("Normal")}
                              </MenuItem>
                              <MenuItem value="Fleet Car">Fleet Car</MenuItem>
                              <MenuItem value="Special Need Car">
                                {t("Special_needs_cars")}
                              </MenuItem>
                              <MenuItem value="Marshal Car">
                                {t("Marshal_cars")}
                              </MenuItem>
                              <MenuItem value="Bewrage Car">
                                {t("Beverage_cars")}
                              </MenuItem>
                              <MenuItem value="Out Of Service Car">
                                {t("Out_of_service")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="select-wrapper">
                          <p>{t("Speed_limit")}</p>
                          <FormControl size="small">
                            <Select
                              value={SpeedLimit}
                              defaultValue={SpeedLimit}
                              name="SpeedLimit"
                              onChange={handleSpeedLimit}
                              IconComponent={ExpandMoreIcon}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value="2">2mph</MenuItem>
                              <MenuItem value="3">3mph</MenuItem>
                              <MenuItem value="4">4mph</MenuItem>
                              <MenuItem value="5">5mph</MenuItem>
                              <MenuItem value="6">6mph</MenuItem>
                              <MenuItem value="7">7mph</MenuItem>
                              <MenuItem value="8">8mph</MenuItem>
                              <MenuItem value="9">9mph</MenuItem>
                              <MenuItem value="10">10mph</MenuItem>
                              <MenuItem value="11">11mph</MenuItem>
                              <MenuItem value="12">12mph</MenuItem>
                              <MenuItem value="13">13mph</MenuItem>
                              <MenuItem value="14">14mph</MenuItem>
                              <MenuItem value="15">15mph</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="select-wrapper">
                          <p></p>
                          <div>
                            <div className="group-btn-wrapper">
                              {yards ? (
                                <button
                                  onClick={yardsHamdle}
                                  className="active"
                                >
                                  {t("Yards")}
                                </button>
                              ) : (
                                <button onClick={yardsHamdle}>
                                  {t("Yards")}
                                </button>
                              )}
                              {meters ? (
                                <button
                                  onClick={metersHandle}
                                  className="active"
                                >
                                  {t("Meters")}
                                </button>
                              ) : (
                                <button onClick={metersHandle}>
                                  {t("Meters")}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="select-wrapper">
                          <p>{t("Show/Hide_Distances")}</p>
                          <FormControl size="small">
                            <Select
                              value={Distances}
                              defaultValue={Distances}
                              name="HideShowDistance"
                              onChange={handleDistance}
                              IconComponent={ExpandMoreIcon}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value="Hide Distances">
                                {t("Hide_distances")}
                              </MenuItem>
                              <MenuItem value="Show Distances">
                                {t("Show_Distances")}
                              </MenuItem>
                              <MenuItem value="Use Fleet Setting">
                                {t("Use_fleet_setting")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="admin-only">
                          <p>{t("Admin_Only")}</p>
                          <div>
                            <div className="checkbox-wrapper ">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    icon={<UnCheckIcon />}
                                    checkedIcon={<CheckAdminIcon />}
                                  />
                                }
                                label={t("Deregister_car")}
                              />
                            </div>
                            <div className="checkbox-wrapper ">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    icon={<UnCheckIcon />}
                                    checkedIcon={<CheckIcon />}
                                  />
                                }
                                label="Stage 10 cars"
                              />
                            </div>
                          </div>
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <div className="action-buttons">
                          <button onClick={saveEntity}>{t("Save")}</button>
                          <button onClick={handleSettingClose}>
                            {t("Cancel")}
                          </button>
                        </div>
                      </DialogActions>
                    </ChangeSettingModalWrapper>
                  </Dialog>
                )}
                <Tag
                  onClick={showTagCarDialogBoxWindow}
                  style={
                    getFeatureSetOption(
                      siteSettingsData?.Features,
                      getFeaturesList().real_time_tracking
                    )
                      ? {
                        backgroundColor: "#d3d3d3",
                        cursor: "no-drop",
                      }
                      : {}
                  }
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData?.Features,
                      getFeaturesList().real_time_tracking
                    ) &&
                    getUserRole &&
                    getUserRole.Role != 6
                  }
                >
                  <CarTagIcon
                    color="var(--inner-section-bg)"
                    width={11.5}
                    height={16}
                  />
                  <span className="display">{t("Find_Cars")}</span>
                </Tag>
              </TagsWrapper>

              <Modal
                open={isLoading.get()}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <MsgToSelectedCarsCmp cancelClick={handleClose} />
                </Box>
              </Modal>
            </ActionWrapper>

            <TagsWrapper>
              <Tag
                onClick={handleToggleSmallList}
                style={{
                  backgroundColor: toggleFleetCarList.get() === fleetViewMode.SmallList ? "var(--theme-background)" : "transparent",
                }}
              >
                <SmallListIcon fill={toggleFleetCarList.get() === fleetViewMode.SmallList ? "#fff" : "#d3d3d3"} />
              </Tag>

              <Tag
                onClick={handleToggleGridList}
                style={{
                  backgroundColor: toggleFleetCarList.get() === fleetViewMode.GridList ? "var(--theme-background)" : "transparent",
                }}
              >
                <BigListIcon fill={toggleFleetCarList.get() === fleetViewMode.GridList ? "#fff" : "#d3d3d3"} />
              </Tag>

              <Tag
                onClick={handleToggleTableList}
                style={{
                  backgroundColor: toggleFleetCarList.get() === fleetViewMode.TableList ? "var(--theme-background)" : "transparent",
                }}
              >
                <TableListIcon fill={toggleFleetCarList.get() === fleetViewMode.TableList ? "#fff" : "#d3d3d3"} />
              </Tag>
            </TagsWrapper>


            <Tooltip title={t("Fleet_legend")}>
              <SettingIconWrapper gIconWrapper>
                <ChangeSettingIcon
                  onClick={handleOpen2}
                  style={{ cursor: "pointer" }}
                />
              </SettingIconWrapper>

            </Tooltip>
          </div>
        )}
      </MobileHeader>
    </>
  );
};
